import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Navbar } from './NavBar';
import Modal from './Modal';
import { AuthContext } from "./AuthContext";

export function Home() {

    const navigate = useNavigate();
    const location = useLocation();
    const [showModal, setShowModal] = useState(false);
    const [message, setMessage] = useState(null);

    const { signOut } = useContext(AuthContext)

    useEffect(() => {
        // Check if there is a message in the location state
        const msg = location.state?.message;
        if (msg) {
            setMessage(msg);
            setShowModal(true);
            navigate(location.pathname, { replace: true });
        }
    }, [location, navigate]);

    return (
        <div className="container">

            <Navbar onClick1={() => navigate("/vote-judge")} onClick2={signOut} text1="Zsűri Bejelentkezés" text2="Kijelentkezés" second/>

            <main className="main-content">
                <p className='main-title-text'>Üdvözöljük az M-Faktor 2025<br/>hivatalos szavazási felületén</p>
                <button className="vote-button" onClick={() => navigate("/vote-fans")}>Tovább a szavazási felületre</button>
            </main>
            {message && <Modal show={showModal} onClose={() => setShowModal(false)}>
                <p style={{color: "black"}}>{message}</p>
            </Modal>}
        </div>

    );
}
